"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ahooks_1 = require("ahooks");
var antd_1 = require("antd");
var react_1 = __importStar(require("react"));
var useConfig_1 = __importDefault(require("../../_util/useConfig"));
var XlsxExport_1 = require("../../_util/XlsxExport");
var Menu_1 = __importDefault(require("./Menu"));
var Table_1 = __importDefault(require("./Table"));
var TabPane = antd_1.Tabs.TabPane;
function TreeTable(props) {
    var _this = this;
    var _a;
    var _b = props.data, leftOptiosData = _b === void 0 ? [] : _b, paginationOpts = props.paginationOpts;
    var _c = paginationOpts || {}, _d = _c.versionText, versionText = _d === void 0 ? '' : _d, _e = _c.featureText, featureText = _e === void 0 ? '' : _e, _f = _c.downloadTitle, downloadTitle = _f === void 0 ? '' : _f;
    var _g = (0, useConfig_1.default)(), classPrefix = _g.classPrefix, mobileWidth = _g.mobileWidth;
    var _h = (0, react_1.useState)(''), selectedItem = _h[0], setSelectedItem = _h[1];
    var _j = (0, react_1.useState)(''), selectedGroup = _j[0], setSelectedGroup = _j[1];
    var _k = (0, react_1.useState)({}), expandedGroups = _k[0], setExpandedGroups = _k[1];
    var _l = (0, react_1.useState)([]), versionList = _l[0], setVersionList = _l[1];
    var _m = (0, react_1.useState)([]), featureList = _m[0], setFeatureList = _m[1];
    var _o = (0, react_1.useState)([]), versionFeatureList = _o[0], setVersionFeatureList = _o[1];
    var _p = (0, react_1.useState)([]), featureDetailMap = _p[0], setFeatureDetailMap = _p[1];
    var _q = (0, react_1.useState)({}), tableData = _q[0], setTableList = _q[1];
    var _r = (0, react_1.useState)(''), version = _r[0], setVersion = _r[1];
    var _s = (0, react_1.useState)(''), featureDetail = _s[0], setFeatureDetail = _s[1];
    var _t = (0, react_1.useState)(''), productDesc = _t[0], setProductDesc = _t[1];
    var _u = (0, react_1.useState)(''), featureDesc = _u[0], setFeatureDesc = _u[1];
    var _v = (0, react_1.useState)(''), feature = _v[0], setFeature = _v[1];
    var _w = (0, react_1.useState)({ row: [], col: [] }), downloadData = _w[0], setDownloadData = _w[1];
    var _x = (0, react_1.useState)(''), selectTitle = _x[0], setSelectTitle = _x[1];
    var ref = (0, react_1.useRef)(null);
    var size = (0, ahooks_1.useSize)(ref);
    var leftOptios = [];
    if (leftOptiosData && leftOptiosData.length > 0) {
        leftOptios = ((_a = leftOptiosData[0]) === null || _a === void 0 ? void 0 : _a.productGroupData) || [];
    }
    var handleItemClick = function (label, groupTitle) {
        if (groupTitle === void 0) { groupTitle = ''; }
        if (label === selectedItem) {
            return false;
        }
        setSelectedItem(label);
        // 如果点击的是分组内的菜单项，设置对应分组选中
        // 如果点击的是单独菜单项，清空分组选中状态
        setSelectedGroup(groupTitle || '');
        setVersionList([]);
        setFeatureList([]);
        setVersion('');
        setFeature('');
        setFeatureDetail('');
        setFeatureDetailMap([]);
        setProductDesc('');
        setFeatureDesc('');
        setTableList([]);
    };
    var handleGroupClick = function (item) {
        setExpandedGroups(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[item.productGroupCode] = !prev[item.productGroupCode], _a)));
        });
    };
    var onTabsChange = function (key) {
        setFeatureDetail(key);
    };
    var menuItems = leftOptios.map(function (item) {
        return __assign(__assign({ group: true }, item), { selectable: false, title: item.productGroupName, label: item.productGroupName, value: item.productGroupCode, isExpanded: expandedGroups[item.productGroupCode], isSelected: selectedGroup === item.productGroupCode, onClick: function () { return handleGroupClick(item); }, items: (item.data || []).map(function (item1) {
                return __assign(__assign({}, item1), { label: item1.productName || item1.productCode, value: item1.productCode, onClick: function () {
                        handleItemClick(item1.productCode, item.productGroupCode);
                    }, isSelected: selectedItem === item1.productCode });
            }), children: (item.data || []).map(function (item1) {
                return __assign(__assign({}, item1), { productGroupCode: item.productGroupCode, title: item1.productName || item1.productCode, value: item1.productCode });
            }), options: item.data.map(function (item1) {
                return __assign(__assign({}, item1), { productGroupCode: item.productGroupCode, label: item1.productName || item1.productCode, value: item1.productCode });
            }) });
    });
    // 根据productGroupCode, productCode从menu中查找产品
    function findProduct(menu, productGroupCode, productCode) {
        for (var _i = 0, menu_1 = menu; _i < menu_1.length; _i++) {
            var group = menu_1[_i];
            if (group.productGroupCode === productGroupCode) {
                for (var _a = 0, _b = group.data; _a < _b.length; _a++) {
                    var product = _b[_a];
                    if (product.productCode === productCode) {
                        return product;
                    }
                }
            }
        }
        return null; // 如果没有找到，返回 null
    }
    // 合并version和feature2个数组为一个group数组
    function megeVersionAndFeature(versionList, featureMap) {
        return versionList.map(function (version) {
            var _a;
            var options = ((_a = featureMap.find(function (feature) { return feature.key === version.key; })) === null || _a === void 0 ? void 0 : _a.data) || [];
            return __assign(__assign({}, version), { label: version.text, options: options.map(function (item) {
                    return __assign(__assign({}, item), { label: item.text, value: item.key, version: version.key });
                }) });
        });
    }
    // 数据变更后处理数据
    function doDataEvent() {
        var _a;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        var selectGroupKey = selectedGroup;
        var selectProductKey = selectedItem;
        var title = '';
        if (!selectGroupKey) {
            // 默认选中第一项
            var defMenuItem = menuItems[0] || {};
            selectGroupKey = defMenuItem.productGroupCode || '';
            selectProductKey = (_c = (_b = defMenuItem === null || defMenuItem === void 0 ? void 0 : defMenuItem.items) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value;
            setExpandedGroups((_a = {}, _a[selectGroupKey] = true, _a));
            setSelectedItem(selectProductKey);
            setSelectedGroup(selectGroupKey);
        }
        // 查找选中元素
        var selectMenuItem = findProduct(leftOptios, selectGroupKey, selectProductKey);
        if (selectMenuItem) {
            var _m = selectMenuItem.featureMap, featureMap = _m === void 0 ? [] : _m, _o = selectMenuItem.featureDetailMap, featureDetailMap_1 = _o === void 0 ? [] : _o, _p = selectMenuItem.versionList, versionList_1 = _p === void 0 ? [] : _p, _q = selectMenuItem.productData, productData = _q === void 0 ? [] : _q, _r = selectMenuItem.productName, productName = _r === void 0 ? '' : _r;
            var versionKey_1 = version;
            var featurekey_1 = feature;
            var featureDetailKey_1 = featureDetail;
            title = productName;
            setProductDesc(selectMenuItem.desc);
            // 合并version和feature为group数组，方便手机端分组展示
            var versionFeatureList_1 = megeVersionAndFeature(versionList_1, featureMap);
            setVersionFeatureList(versionFeatureList_1);
            if ((versionList_1 === null || versionList_1 === void 0 ? void 0 : versionList_1.length) && !versionKey_1) {
                versionKey_1 = ((_d = versionList_1[0]) === null || _d === void 0 ? void 0 : _d.key) || '';
                var versionTitle = ((_e = versionList_1[0]) === null || _e === void 0 ? void 0 : _e.text) || '';
                title = title.concat('-', versionTitle);
                setVersionList(versionList_1.map(function (_a) {
                    var key = _a.key, text = _a.text;
                    return ({ value: key, label: text });
                }));
                setVersion(versionKey_1);
            }
            else {
                var versionItem = versionList_1.find(function (item) { return item.key === versionKey_1; });
                title = title.concat('-', versionItem.text);
            }
            if (versionKey_1) {
                var featureItem = featureMap.find(function (item) { return item.key === versionKey_1; });
                var featrueList = featureItem.data;
                if (((_f = featureItem === null || featureItem === void 0 ? void 0 : featureItem.data) === null || _f === void 0 ? void 0 : _f.length) && !featurekey_1) {
                    featurekey_1 = ((_g = featrueList[0]) === null || _g === void 0 ? void 0 : _g.key) || '';
                    var featureTitle = ((_h = featrueList[0]) === null || _h === void 0 ? void 0 : _h.text) || '';
                    title = title.concat('-', featureTitle);
                    setFeatureList(featrueList.map(function (_a) {
                        var key = _a.key, text = _a.text;
                        return ({ value: key, label: text });
                    }));
                    setFeature(featurekey_1);
                }
                else {
                    var featrueItem = featrueList.find(function (item) { return item.key === featurekey_1; });
                    title = title.concat('-', featrueItem.text);
                }
            }
            if (featurekey_1) {
                var featureDetail_1 = featureDetailMap_1.find(function (item) { return item.key === featurekey_1; });
                var featureDetailList = featureDetail_1.data;
                if (((_j = featureDetail_1 === null || featureDetail_1 === void 0 ? void 0 : featureDetail_1.data) === null || _j === void 0 ? void 0 : _j.length) && !featureDetailKey_1) {
                    featureDetailKey_1 = ((_k = featureDetailList[0]) === null || _k === void 0 ? void 0 : _k.key) || '';
                    var featureDetailTitle = ((_l = featureDetailList[0]) === null || _l === void 0 ? void 0 : _l.text) || '';
                    title = title.concat('-', featureDetailTitle);
                    setFeatureDetail(featureDetailKey_1);
                    setFeatureDetailMap(featureDetailList.map(function (_a) {
                        var key = _a.key, text = _a.text;
                        return ({ key: key, label: text });
                    }));
                }
                else {
                    var featureDetailItem = featureDetailList.find(function (item) { return item.key === featureDetailKey_1; });
                    title = title.concat('-', featureDetailItem.text);
                }
            }
            if (featureDetailKey_1) {
                var filterProductData = productData
                    .filter(function (item) { return item.version === versionKey_1; }) // 筛选版本
                    .flatMap(function (versionItem) {
                    return versionItem.data
                        .filter(function (featureItem) { return featureItem.feature === featurekey_1; }) // 筛选功能
                        .flatMap(function (featureItem) {
                        return featureItem.data.filter(function (detailItem) { return detailItem.featureDetailKey === featureDetailKey_1; });
                    });
                });
                if (filterProductData === null || filterProductData === void 0 ? void 0 : filterProductData[0]) {
                    var tableData_1 = filterProductData[0];
                    setTableList(tableData_1.data);
                    setFeatureDesc(tableData_1.desc);
                }
            }
            setSelectTitle(title);
        }
    }
    // 构造下载的数据
    function transformedData(row, col) {
        return row.map(function (item) {
            var newObj = {};
            item.data.forEach(function (dataItem) {
                var config = col.find(function (configItem) { return configItem.key === dataItem.key; });
                if (config) {
                    var excelText = dataItem.text.replace(/<br\s*\/?>/gi, '\r\n'); // 将br换为excel支持的换行符
                    newObj[config.text] = excelText;
                }
            });
            return newObj; // 直接返回新对象，去掉 data 层
        });
    }
    // 下载excel
    var handleDownloadClick = function () { return __awaiter(_this, void 0, void 0, function () {
        var row, col, result, title;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!(((_a = downloadData === null || downloadData === void 0 ? void 0 : downloadData.row) === null || _a === void 0 ? void 0 : _a.length) > 0)) return [3 /*break*/, 2];
                    row = downloadData.row, col = downloadData.col;
                    result = transformedData(row, col);
                    title = '';
                    if (downloadTitle) {
                        title = downloadTitle.concat('-', selectTitle);
                    }
                    else {
                        title = selectTitle;
                    }
                    return [4 /*yield*/, (0, XlsxExport_1.exportWithWrapText)(result, title)];
                case 1:
                    _b.sent();
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        if (menuItems && menuItems.length > 0) {
            doDataEvent();
        }
    }, [leftOptiosData, selectedItem, version, feature, featureDetail]);
    function renderPcMenu() {
        return (react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-left-menu") },
            react_1.default.createElement(Menu_1.default, { items: menuItems })));
    }
    function renderMobileMenu() {
        return (react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-mobile-menu") },
            react_1.default.createElement(antd_1.Select, { className: "".concat(classPrefix, "__treeTable-mobile-menu-select"), value: selectedItem, onChange: function (value, info) {
                    handleItemClick(value, info.productGroupCode);
                }, options: menuItems }),
            react_1.default.createElement(antd_1.Select, { className: "".concat(classPrefix, "__treeTable-mobile-menu-select margin16"), value: feature, onChange: function (value, info) {
                    setVersion((info === null || info === void 0 ? void 0 : info.version) || '');
                    setFeature(value);
                    setFeatureDetail('');
                    setFeatureDetailMap([]);
                    setFeatureDesc('');
                    setTableList([]);
                }, options: versionFeatureList }),
            react_1.default.createElement(antd_1.Button, { block: true, className: "".concat(classPrefix, "__treeTable-mobile-menu-btn"), onClick: function () { return void handleDownloadClick(); } }, paginationOpts.downloadText || 'Download')));
    }
    function renderPcSelect() {
        return (react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-right-options") },
            react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-right-options-select-warpper") },
                react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-right-options-select-warpper-label") }, versionText),
                react_1.default.createElement(antd_1.Select, { className: "".concat(classPrefix, "__treeTable-right-options-select-warpper-mySelect"), options: versionList, value: version, placeholder: '请选择 TCE 版本', onChange: function (value) {
                        setVersion(value);
                        setFeatureList([]);
                        setFeature('');
                        setFeatureDetail('');
                        setFeatureDetailMap([]);
                        setFeatureDesc('');
                        setTableList([]);
                    } }),
                react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-right-options-select-warpper-label") }, featureText),
                react_1.default.createElement(antd_1.Select, { className: "".concat(classPrefix, "__treeTable-right-options-select-warpper-mySelect"), options: featureList, value: feature, placeholder: '请选择 TCE 云产品特性', onChange: function (value) {
                        setFeature(value);
                        setFeatureDetail('');
                        setFeatureDetailMap([]);
                        setFeatureDesc('');
                        setTableList([]);
                    } })),
            react_1.default.createElement(antd_1.Button, { onClick: function () { return void handleDownloadClick(); } }, paginationOpts.downloadText || 'Download')));
    }
    return (react_1.default.createElement(antd_1.Spin, { spinning: Object.keys(tableData).length === 0, size: "large" },
        react_1.default.createElement("div", { ref: ref, className: "".concat(classPrefix, "__treeTable") },
            Number(size === null || size === void 0 ? void 0 : size.width) <= mobileWidth ? renderMobileMenu() : renderPcMenu(),
            react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-right-content") },
                react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-right-top-desc") }, productDesc),
                Number(size === null || size === void 0 ? void 0 : size.width) > mobileWidth && renderPcSelect(),
                react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-right-tab") },
                    react_1.default.createElement(antd_1.Tabs, { onChange: onTabsChange }, featureDetailMap.map(function (item) {
                        return (react_1.default.createElement(TabPane, { key: item.key, tab: item.label },
                            react_1.default.createElement(Table_1.default, { data: tableData, paginationOpts: paginationOpts, dataFilterCallback: function (row, col) {
                                    setDownloadData({ row: row, col: col });
                                } }),
                            featureDesc && (react_1.default.createElement("div", { className: "".concat(classPrefix, "__treeTable-right-tab-desc") }, featureDesc))));
                    })))))));
}
exports.default = TreeTable;
//# sourceMappingURL=TreeTable.js.map